// Copy for AssessmentSessionSummary — the one-line "which ice time" caption
// shared by the player communication log and the staff send history.

import { defineMessages } from 'react-intl';

import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.AssessmentSessionSummary';

// Labelled with the association's own word for a session ("Ice Time" for hockey).
export const getMessages = (termLookup: SportTermLookup) => {
  const sessionTerm = termLookup[SportTerminology.SESSION];
  return defineMessages({
    summary: {
      id: `${scope}.summary`,
      defaultMessage: `${sessionTerm}: {when}`
    }
  });
};
